module.exports = __webpack_public_path__ + "img/swindle.266fbef3.png";